// extracted by mini-css-extract-plugin
export default {"list":"index_list__3iXqn typography_paragraphLarge__2TbDH typography_bodyFont__3RHTp","listItem":"index_listItem__2aqmM"};